import { writable } from "svelte/store";
import * as api from "../apis/memoMng.api";

const createInitialState = () => ({
    dvyfg_de: "",
    memoMngList: [],
    currentList: [],

    weekdays: [], // 월~금 요일과 날짜를 담을 배열
    selectedDate: null, // 현재 선택된 날짜
    savedSelectedDate: null, // 저장된 선택된 날짜
    startOfWeek: new Date(
        new Date().setDate(new Date().getDate() - (new Date().getDay() - 1))
    ), // 현재 주의 시작 날짜를 저장
    firstLoad: true,
    isClicked: false,
    keyword: "",
});

export const store = writable(createInitialState());

export function resetMemoMngStore() {
    store.set(createInitialState());
}

export async function apiGetMemoMng(dvyfg_de, keyword) {
    try {
        const response = await api.apiGetMemoMng(dvyfg_de, keyword);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiGetMemoMngDetail(rcvord_no) {
    try {
        const response = await api.apiGetMemoMngDetail(rcvord_no);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}

export async function apiPutMemoMng(rcvord_no, dvyfg_de, memo) {
    try {
        let formData = {
            rcvord_no: rcvord_no,
            dvyfg_de: dvyfg_de,
            memo: memo,
        };

        const response = await api.apiPutMemoMng(formData);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                alert(response.data.msg);
                return "";
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        console.error("Error - store : ", e);
        alert(
            "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
        );
    }
}
